<template>
  <div id="checkup-plus-alerts-table">

    <div class="table-container">
      <div class="text-center loading-overlay" v-if="isLoading">
        <LoadingAnimation/>
      </div>

      <div class="row mt-2 no-gutters evollu-form" v-if="showFilters">
        <div class="col-12 col-md-4 mr-3">
          <range-date-picker
            id="alerts-date-range"
            :label="$t('statistics2.hear.sublabels.period')"
            v-model="filters.dates"
            :placeholder="this.$t('agenda.reports.date_range')"
            :config="{ maxInterval: { value: 6, unit: 'months' } }"
            :clearable="false"
          />
        </div>

        <div class="col-12 col-md-4">
          <label class="form-label">
            {{ $t('entities.activities.status') }}
          </label>
          <multiselect
            id="entities-filter"
            v-model="filters.open"
            :options="openStatusesOptions"
            track-by="id"
            :customLabel="(elem) => $t(elem.labelKey)"
            :placeholder="$t('entities.activities.status')"
            :allow-empty="true"
            :multiple="false"
            :internal-search="true"
          >

            <template slot="clear">
              <!--<span class="multiselect__clear" v-if="filters.entities.length"
                    @mousedown.prevent.stop="filters.entities = []"></span>-->
              <span class="multiselect__clear" v-if="filters.open !== null"
                    @mousedown.prevent.stop="filters.open = null"></span>
            </template>
          </multiselect>
        </div>
      </div>
      <v-server-table
        :columns="columns"
        :options="tableOptions"
        ref="checkupPlusAlertsTable"
        id="checkupPlusAlertsTable"
        name="checkupPlusAlertsTable"
      >
      <span slot="date" slot-scope="{row}">
        {{ row.date ? moment(row.date).format("YYYY/MM/DD") : "N/A" }}
      </span>

        <span slot="alarmType" slot-scope="{row}">
        {{ row.alarmtypeId ? $t(`checkup_plus.alerts.alarmTypes.${row.alarmtypeId}`) : "N/A" }}
      </span>
      </v-server-table>
    </div>
  </div>
</template>

<script>
import LoadingAnimation from "@/components/users/components/Helpers/LoadingAnimation.vue";
import TableQueryMixin from "@/mixins/TableQueryMixin.vue";
import {OneCareService} from "@/api/OneCareService";
import ApiService from "@/api/ApiService";
import axios from "axios";
import {mapState} from "vuex";
import Multiselect from "vue-multiselect";
import RangeDatePicker from "@/components/common/RangeDatePicker.vue";

export default {
  components: {RangeDatePicker, LoadingAnimation, Multiselect},
  mixins: [TableQueryMixin],
  props: {
    showFilters: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function() {
    return {
      isLoading: false,
      queryUrl: `${OneCareService.baseURL}/alarms?includePhotos=false`,
      tableOptions: {
        requestFunction: (data) => {
          const page = data.page
          this.isLoading = true
          return new Promise((resolve, reject) => {
            if (this.cancelationCallback !== null) {
              this.cancelationCallback()
            }
            const limit = this.$refs.checkupPlusAlertsTable ? this.$refs.checkupPlusAlertsTable.limit : 10
            const queryUrl = this.queryUrl + `&pageSize=${limit}`

            if(!data.start) {
              data.start = this.filters.dates.start
            }
            if(!data.end) {
              data.end = this.moment(this.filters.dates.end).add(1, 'day').format('YYYY/MM/DD')
            }

            if(!data.open) {
              delete data.open
            }

            ApiService.cancelableQuery(queryUrl, data, new axios.CancelToken(c => {
              this.cancelationCallback = c
            }))
              .then(response => {
                if (response.data.page) {
                  if (this.getTableReference) {
                    this.getTableReference().$refs.pagination.Page = response.data.page
                  }
                } else if (page) {
                  if (this.getTableReference) {
                    this.getTableReference().$refs.pagination.Page = page
                  }
                }
                this.hasMadeFirstLoad = true
                resolve({
                  data: response.data.objects ? response.data.objects : [],
                  count: response.data.totalItems ? response.data.totalItems : 0,
                  page: response.data.page ? response.data.page : 1
                })
              })
              .catch(error => {
                if (!axios.isCancel(error)) {
                  reject(error)
                }
              })
              .finally(() => {
                this.isLoading = false
              })
          })
        },
        filterable: true,
        sortable: [],
        customFilters: ['start', 'end', 'open'],
        skin: 'table table-striped table-hover is-fullwidth',
        headings: {
          personName: this.$t('checkup_plus.alerts.table.patientName'),
          date: this.$t('checkup_plus.alerts.table.date'),
          alarmType: this.$t('checkup_plus.alerts.table.alarmType'),
        },
      },
      columns: ['date', 'personName', 'alarmType'],
      filters: {
        dates: {
          start: this.moment().subtract(1, 'month').format('YYYY/MM/DD'),
          end: this.moment().format('YYYY/MM/DD')
        },
        open: null,
      },
      openStatusesOptions: [
        {
          id: 1,
          type: 'false',
          description: 'openFalse',
          labelKey: 'checkup_plus.alerts.open_statuses_options.resolved'
        },
        {
          id: 2,
          type: 'true',
          description: 'openTrue',
          labelKey: 'checkup_plus.alerts.open_statuses_options.unsolved'
        }
      ]
    }
  },
  async mounted() {
    //await this.loadLocalStorage()
    this.getTableReference().setFilter('')
    this.getTableReference().setLimit(10)
    this.getTableReference().orderBy = {
      'ascending': false,
      'column': false
    }
  },
  methods: {
    getTableReference: function () {
      return this.$refs.checkupPlusAlertsTable
    },
  },
  computed: {
    ...mapState({
      oneCareToken(state, getters) {
        return getters['oneCareToken'] || []
      },
    })
  },
  watch: {
    'filters.dates': {
      handler: function (value) {
        if (this.getTableReference() !== undefined) {
          if (value.start === null || value.end === null) {
            this.getTableReference().customQueries.start = null
            this.emitTableFilter('vue-tables.checkupPlusAlertsTable.filter::end', null)
          } else {
            this.getTableReference().customQueries.start = this.moment(value.start).format('YYYY/MM/DD') || ''
            this.emitTableFilter('vue-tables.checkupPlusAlertsTable.filter::end', this.moment(value.end).format('YYYY/MM/DD') || '')
          }
        }
      },
      immediate: false,
      deep: true,
    },
    'filters.open': {
      handler: function(value) {
        if(this.getTableReference() !== undefined) {
          this.emitTableFilter('vue-tables.checkupPlusAlertsTable.filter::open', value ? value.type : null)
        }
      },
      immediate: false,
      deep: true
    }
  }
}
</script>

<style scoped>
.table-container {
  position: relative;
}

.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.7); /* Semi-transparent white background */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999; /* Ensure it appears above the table */
}
</style>
